// Email validation
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

// Storage keys
export const STORAGE_KEY_B2C_PREFS = 'b2c_prefs';
export const STORAGE_KEY_B2C_PENDING_EMAIL = 'b2c_pending_email';
export const STORAGE_KEY_USER_TYPE = 'userType';
export const STORAGE_KEY_IS_KC_STUDENT = 'isKCStudent';
export const STORAGE_KEY_B2C_SOURCE_URL = 'b2c_pending_source_url';
export const STORAGE_KEY_B2C_PRIMARY_SOURCE = 'b2c_pending_primary_source';
export const STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE = 'b2c_pending_fifth_step_visible';
export const STORAGE_KEY_B2C_COACHING_VISIBLE = 'b2c_pending_coaching_visible'; // CFM-1514

// primary_source tags forwarded to Frappe at lead creation
export const PRIMARY_SOURCE_B2C_WIDGET = 'B2C Widget';
export const PRIMARY_SOURCE_B2C_LOGIN = 'B2C Login';

// Cookie names
export const COOKIE_NAME_B2C_USER_TYPE = 'b2cUserType';

// CF app URL — used when building cross-app redirect URLs
export const CF_APP_URL = process.env.NEXT_PUBLIC_CF_APP_URL as string;

// Free counselling booking page — opened from "Book Online Counselling" buttons across
// home header + B2C search results page. Keep in sync if marketing renames the URL.
export const BOOK_COUNSELLING_URL = 'https://app.studies-overseas.com/book-free-study-abroad-counselling';

// Forces the home page "Start Your Journey" CTA to route to /onboarding,
// regardless of the CMS `heroSectionBtn.toOnboardingEnabled` field.
// Flip to false (or wire CMS back in) when product owns the toggle in Strapi.
export const HOME_HERO_ONBOARDING_ENABLED = true;

// Frappe CRM credentials
export const FRAPPE_URL = process.env.NEXT_PUBLIC_FRAPPE_CRM_URL;
export const FRAPPE_API_KEY = process.env.NEXT_PUBLIC_FRAPPE_API_KEY;
export const FRAPPE_API_SECRET = process.env.NEXT_PUBLIC_FRAPPE_API_SECRET;

// CFM-1579: CF master country id for the USA. Mirrors COUNTRY_USA_CODE in coursefinder-react.
export const COUNTRY_USA_CODE = 1;

// CFM-1685: placeholder copy for the sponsored card's info tooltip, pending final wording from
// product. coursefinder-react holds its own copy in utils/b2cConstants.tsx (separate repo, no
// shared package) — update both when the real wording lands.
export const SPONSORED_TOOLTIP =
  'This university is featured as a sponsored placement.';

// CFM-1685: Featured leads the list and is therefore the default, mirroring search-program.
// It only reorders results — there is no featured badge anywhere.
//
// No tuition / application fee sorts here, deliberately. Fees belong to a course, not a
// university — a university has a range — and this card shows one program out of many.
// search-program disables them on its Universities tab ("To sort, please switch to the Programs
// tab"); this site has no Programs tab, so they are left out entirely, matching the CF student
// platform. Don't re-add them for parity.
export const SORT_OPTIONS = [
  { label: 'Featured', value: 'Featured' },
  { label: 'Ranking',  value: 'Ranking'  },
];

// Country name → ISO 3166-1 alpha-2 code (used for flag icons)
export const COUNTRY_CODES: Record<string, string> = {
  'United States of America': 'us', 'Australia': 'au', 'Canada': 'ca',
  'United Kingdom': 'gb', 'New Zealand': 'nz', 'Singapore': 'sg',
  'United Arab Emirates': 'ae', 'Ireland': 'ie', 'Germany': 'de',
  'France': 'fr', 'Sweden': 'se', 'Netherlands': 'nl', 'Austria': 'at',
  'Denmark': 'dk', 'Finland': 'fi', 'Italy': 'it', 'Hungary': 'hu',
  'Switzerland': 'ch', 'Spain': 'es', 'Lithuania': 'lt', 'Latvia': 'lv',
  'Cyprus': 'cy', 'Poland': 'pl', 'Czech Republic': 'cz', 'Malaysia': 'my',
  'Mauritius': 'mu', 'South Africa': 'za', 'Hong Kong': 'hk', 'China': 'cn',
  'Bulgaria': 'bg', 'Vietnam': 'vn', 'Malta': 'mt', 'Japan': 'jp',
  'Belgium': 'be', 'Russia': 'ru', 'South Korea': 'kr', 'India': 'in',
  'Indonesia': 'id', 'Georgia': 'ge', 'Zimbabwe': 'zw', 'Turkey': 'tr',
};

// Static intake period options — update annually or replace with API when available
export const INTAKE_OPTIONS = [
  { label: 'May 2026', value: 'May 2026' },
  { label: 'September 2026', value: 'September 2026' },
  { label: '2026 Intakes', value: '2026 Intakes' },
  { label: '2027 Intakes', value: '2027 Intakes' },
];

export const CLOSED_REASONS: Record<number, string> = {
  1: 'Deadline Passed',
  2: 'Closed by KC',
  3: 'Seats Full',
};

export const DEFAULT_CLOSED_REMARK =
  'Either the Application deadline for this course has passed or we have stopped accepting Applications for this intake hence you cannot shortlist or apply for the same.';
